<template>

    <div class="w-full">

        <div class="flex flex-wrap w-full font-bold bg-gray-300 rounded text-gray-800 shadow-md mb-6">
			<div class="flex-1 text-left py-3 px-4 w-full md:w-auto md:text-right">
				<button v-on:click="viewModal" class="bg-blue-700 text-white rounded px-2 py-1 md:ml-3 ml-0 mr-3 md:mr-0 mt-3 md:mt-0">
					Add User
				</button>
			</div>
		</div>

		<CustomTable class="bg-white rounded shadow-md group">
			<template v-slot:header>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Name</th>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Email</th>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Permissions</th>
				<th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">User Since</th>
			</template>
			<template v-slot:body>
				<tr class="hover:bg-grey-lighter" v-for="user in users" v-if="!polling">
					<td class="py-4 px-6 border-b border-grey-light"><router-link :to="{ name: 'AdminUserDetails', params: { id: user.id }}" class="text-blue-600">{{ user.name }}</router-link></td>
					<td class="py-4 px-6 border-b border-grey-light">{{ user.email }}</td>
					<td class="py-4 px-6 border-b border-grey-light">{{ user.role | displayRole}}</td>
					<td class="py-4 px-6 border-b border-grey-light">{{ user.created_at }}</td>
				</tr>
				<tr class="bg-grey-lighter text-center" v-if="polling">
					<td class="py-5" colspan="4">
						<h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
					</td>
				</tr>
			</template>
		</CustomTable>

		<add-user-modal></add-user-modal>

	</div>

</template>

<script>

	import { EventBus } from '../../../utils/events';
	import * as Config from '../../../config'
	import { mapState, mapGetters } from 'vuex';
	import AddUserModal from '../modals/AddUserModal'
	import CustomTable from '@/components/general/CustomTable'

	export default {
		name: 'Users',
		data () {
			return {
				users: {},
				polling: true,
			}
		},
		components: {
			'add-user-modal': AddUserModal,
			CustomTable
		},
		mounted() {
			this.getUsers();

			this.$nextTick(function () {
                EventBus.$on('admin-add-user-refresh-data', this.getUsers);
            }.bind(this));
		},
		methods: {
			...mapGetters([
                'getAuthorizationHeader',
            ]),
			getUsers() {
                this.$http.get(Config.apiPath + "/api/v2/admin/users", this.getAuthorizationHeader()).then((response) => {
					this.$set(this, 'users', response.data)
                    this.$set(this, 'polling', false)
                });
			},
			viewModal() {
                EventBus.$emit('admin-add-user-open-modal');
            },
		},
		filters: {
			displayRole: function(data) {
				if(data == 'videographer') {
					return 'Videographer'
				} else if (data == 'media_purchaser') {
					return 'Media Purchaser'
				} else if (data == 'media_producer') {
					return 'Media Producer'
				} else if (data == 'administrator') {
					return 'Administrator'
				} else if (data == 'superadministrator') {
					return 'Super Administrator'
				}
			}
		}
	}
</script>
